exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-419d0c76] .el-card__body{height:100%}.card__body--nopadding[data-v-419d0c76]  .el-card__body{padding:10px}.modelTree-tree[data-v-419d0c76]{height:calc(100% - 84px)}", ""]);

// exports
